<script>
    import { query, FreeTerm } from '../stores'
    import OPTS from '../options';

    let search_text = "";

    function search() {
        if (search_text.trim() !== "")
            query.add(new FreeTerm(search_text))

        search_text = "";
    }
</script>

<form on:submit|preventDefault={search}>
    <div class="form-group">
        <label for="input-refine" class="text-small">raffina la ricerca</label>
        <div class="wrap-refine d-flex justify-content-between">
            <input bind:value={search_text} type="text" class="form-control" id="input-refine" placeholder="">
            <button type="submit" class="btn">
                <img src="{`${OPTS.base_url}img/search-black.svg`}" data-rjs="2">
            </button>
        </div>
    </div>
</form>
